module.exports = __webpack_public_path__ + "media/images/athletes/3427-e6704cc565eed4899e34f33c446fb8d4.png";